import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYelp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-label": "yelp source icon",
	style: { color: "#D32323" },
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M28 5c4-2 9-2 13 0 2 1 2 3 1 5L34 24c-1 2-4 2-5 0L21 11c-1-2 0-5 2-6l5 0z" }),
			/* @__PURE__ */ _jsx("path", { d: "M6 20l16 4c2 .5 3 3 1 4L12 39c-2 1-5 0-6-2L3 27c-1-3 1-6 3-7z" }),
			/* @__PURE__ */ _jsx("path", { d: "M7 43l15-7c2-1 4 1 4 3l-1 16c0 3-3 4-5 3l-11-6c-3-2-4-6-2-9z" }),
			/* @__PURE__ */ _jsx("path", { d: "M33 42l12-12c2-2 4-1 5 1l4 15c1 3-2 5-5 4l-15-4c-3-1-3-3-1-4z" }),
			/* @__PURE__ */ _jsx("path", { d: "M33 29l17-2c3 0 4 2 3 4l-6 12c-1 2-4 2-5 0l-10-11c-2-2-1-3 1-3z" })
		]
	})
});
export default SvgYelp;
